var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDateHover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.802,
    height: 21.999,
    viewBox: "0 0 25.802 21.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 2.95,
    transform: "translate(7.304)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2.95,
    transform: "translate(16.551)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 23.749,
    transform: "translate(0.053 7.498)",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.749,
    height: 17.05,
    rx: 4,
    transform: "translate(0.053 2.949)",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(10.211 11.246)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(3.723 14.996)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(10.211 14.996)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 2.95,
    transform: "translate(17.551 11.246)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H19.748C21.957,0,23.7,2.368,23.7,4.577c.006,0-23.707.165-23.748,0C-.053,2.368,1.791,0,4,0Z",
    transform: "translate(0.053 2.949)",
    fill: "#959cf2",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDateHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dateHover.74cd2722.svg";
export { ForwardRef as ReactComponent };